var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.2932L5.25 8.54321L6.3 7.45571L8.25 9.40571V3.29321H9.75V9.40571L11.7 7.45571L12.75 8.54321L9 12.2932ZM4.5 15.2932C4.0875 15.2932 3.7345 15.1465 3.441 14.853C3.1475 14.5595 3.0005 14.2062 3 13.7932V11.5432H4.5V13.7932H13.5V11.5432H15V13.7932C15 14.2057 14.8533 14.559 14.5597 14.853C14.2662 15.147 13.913 15.2937 13.5 15.2932H4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.2838a315f78288f9584a0d39e7d722d4.svg";
export { ForwardRef as ReactComponent };